<template>
  <el-row>
    <el-col :span="24">
      <el-card class="data" v-loading="loading">
        <div class="data-title flex-space-between" slot="header">
          <p>Entry</p>
          <div>
            <el-tooltip content="Insert" placement="top">
              <el-button
                type="success"
                circle
                icon="el-icon-check"
                @click.prevent="insert()"
              ></el-button>
            </el-tooltip>
          </div>
        </div>
        <Table />
        <Dialog />
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import Table from './TableEntity'
import Dialog from './DialogEntry'
import { mapState, mapMutations } from 'vuex'

export default {
  components: {
    Table,
    Dialog
  },

  computed: {
    ...mapState('faq', ['loading'])
  },

  methods: {
    ...mapMutations('faq', ['setDialogEntry', 'setSelectedEntry']),
    initialEntry() {
      return {
        id: null,
        title: null,
        text: null,
        position: 0,
        category_id: null
      }
    },
    insert() {
      this.setDialogEntry(true)
      this.setSelectedEntry(this.initialEntry())
    }
  }
}
</script>
